<template>
    <div class="bg-white rounded box-shadow p-3">
        <b-modal id="add-role" size="lg" title="Add Roles" hide-footer>
            <div v-show="show"
                 class="alert alert-danger alert-dismissible fade show" role="alert">
                    <span v-for="(err, index) in validation_errors" :key="index">
                      {{ err[0] }} <br/>
                    </span>
            </div>
            <div class="modal-content bg-white rounded box-shadow">
                <div class="form-row">
                    <div class="col-md-12 col-sm-12 col-lg-12">
                        <label for="roles" class="col-form-label col-form-label-sm"
                        >Select Role
                        </label>
                        <multiselect
                                v-model="user.roles"
                                :multiple="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                label="name"
                                track-by="id"
                                :preselect-first="false"
                                :options="roles"
                                name="roles"
                                id="roles"
                                placeholder="Select Roles"
                        ></multiselect>
                        <div class="invalid-feedback">
                            Please Select Role
                        </div>
                    </div>
                </div>
                <div class="form-row mt-3 mb-3">
                    <div class="float-right">
                        <span  v-if="userPermission.includes('role-assign-create')">
                            <b-button variant="success" v-if="!this.btn_edit" class="form-control-sm mr-2" size="sm" @click.prevent="save">
                                Add
                            </b-button>
                        </span>
                        <span v-if="userPermission.includes('role-assign-update')">
                            <b-button variant="warning" v-if="this.btn_edit" class="form-control-sm mr-2" size="sm" @click.prevent="update(user.id)">
                                Update
                            </b-button>
                        </span>
                        <b-button
                                size="sm"
                                variant="danger"
                                class="form-control-sm"
                                @click="$bvModal.hide('add-role')"
                        >Cancel</b-button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import http from "@state/http";
    import Multiselect from "vue-multiselect";

    export default {
        name: "AddRole",
        props: ["user", "roles", "btn_edit", "user_id"],
        components: {Multiselect},
        data() {
            return {
                validation_errors: {},
                show: false,
            };
        },

        methods: {
            save() {
                this.user.user_id = this.user_id;
                http
                    .post("api/user/role/store", this.user)
                    .then(response => {
                        if (!response.data.error) {
                            if (response.data.permissionError) {
                                this.$bvToast.toast(response.data.permissionError, {
                                    title: "Error",
                                    autoHideDelay: 5000,
                                    variant: "danger"
                                });
                            } else {
                                this.$bvToast.toast(response.data.message, {
                                    title: "Success",
                                    autoHideDelay: 5000,
                                    variant: "success"
                                });
                                this.$bvModal.hide("add-role");
                                this.$emit("getUsers");
                            }
                        }
                    })
                    .catch(error => {
                        this.validation_errors = error.response.data.errors;
                        this.show = true;
                        this.hide();
                        // this.$bvModal.hide("add-role");
                    });

            },
            update(user_id) {
                http
                    .post("api/user/role/update/" + user_id, this.user)
                    .then(response => {
                        if (!response.data.error) {
                            if (response.data.permissionError) {
                                this.$bvToast.toast(response.data.permissionError, {
                                    title: "Error",
                                    autoHideDelay: 5000,
                                    variant: "danger"
                                });
                            } else {
                                this.$bvToast.toast(response.data.message, {
                                    title: "Success",
                                    autoHideDelay: 5000,
                                    variant: "success"
                                });
                                this.$bvModal.hide("add-role");
                                this.$emit("getUsers");
                            }
                        }
                    })
                    .catch(error => {
                        this.validation_errors = error.response.data.errors;
                        this.show = true;
                        this.hide();
                    });
            },
            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            }
        },
        computed: {
            userPermission () {
                return this.$store.state.user
            }
        },
        created () {
            this.$store.dispatch('getUserPermission')
        },
    };
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
